import {Link} from "react-router-dom";
// MUIのコンポーネントをインポート
import { Grid, Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

// コンポーネントのプロパティ型の定義
type Props = {
    text: string[],  // ボタンに表示するテキスト配列（5行）
    level: number;   // レベル情報
}

/** user home メインボタン */
// スタイル付きPaperコンポーネントの定義
const Item = styled(Paper)(({ theme }) => ({
    // テーマの設定を継承
    ...theme.typography.body2,
    // テキストの中央寄せ
    textAlign: 'center',
    // テキストカラーの設定
    color: theme.palette.text.secondary,
    // ボタンの高さ
    height: 60,
    // ホバー時のスタイル
    '&:hover': {
        color: 'red',
    },
}));

// UHNButtonコンポーネントの定義
const UHNButton = (props: Props) => {
    return (
        <>
            {/* レスポンシブグリッドアイテム */}
            <Grid item xs={11.99} sm={3.99} md={2.99} lg={1.99}>
                {/* ボタンのコンテナ */}
                <Box
                    sx={{
                        height: 40,
                        bgcolor: 'background.default',
                        marginBottom: 3,
                    }}
                >
                    {/* リンクの設定 */}
                    <Link to={
                        // 条件に応じてリンク先を変更
                        props.text[1] === '初級・中級・上級コース問題集' ?
                        `/problems` :  // 問題集へのリンク
                        `/collection?lv=${props.level}`  // コレクションへのリンク
                    }
                    style={{textDecoration: 'none'}}  // リンクの下線を削除
                    >
                        {/* ボタンの内容 */}
                        <Item elevation={1} sx={{fontSize: 11, lineHeight: 0.8, padding: 1}} >
                            {/* 5行のテキストを表示 */}
                            {props.text[0]}<br />
                            {props.text[1]}<br />
                            {props.text[2]}<br />
                            {props.text[3]}<br />
                            {props.text[4]}<br />
                        </Item>
                    </Link>             
                </Box>  
            </Grid>
        </>
    );
}

export default UHNButton;